'use client';

import { useRef, useState } from 'react';
import classNames from 'classnames';
import { PortalStyleConfig, ThemeColorSchemas, PortalThemeKeys } from '@nx-frontend/shared/types';
import { ThemeCard } from './theme-card';
import './theme-item.css';

export interface OnThemeSelect {
  onSelect: (key: PortalThemeKeys) => void;
}

interface ThemeItemProps extends OnThemeSelect {
  selected: boolean;
  themeKey: PortalThemeKeys;
  themeName: string;
  thumbnail: string;
  styleConfig: PortalStyleConfig;
  themeColors: ThemeColorSchemas;
  selectComingSoonThemes: boolean;
  comingSoon?: boolean;
  onDetailedSettings?: () => void;
  description?: string;
  itemClass?: string;
  showSelected?: boolean;
  showStatus?: boolean;
  showEdit?: boolean;
}

export const ThemeItem: React.FC<ThemeItemProps> = ({
  selected,
  themeKey,
  themeName,
  thumbnail,
  onSelect,
  themeColors,
  comingSoon,
  selectComingSoonThemes,
  onDetailedSettings,
  showSelected,
  itemClass,
  showStatus,
  showEdit,
}) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [hideSelected] = useState(!showSelected && selected);

  return (
    <div
      data-key={themeKey}
      className={classNames(
        'flex flex-col relative border hover:bg-neutral-100 rounded-lg bg-white p-3 cursor-pointer w-full',
        {
          'hover': !comingSoon || selectComingSoonThemes,
          'border-cyan-900': selected,
          'border-neutral-200': !selected,
          'hidden': hideSelected,
        },
        itemClass
      )}
      ref={targetRef}
      onClick={() => {
        if ((!comingSoon && !selected) || (selectComingSoonThemes && !selected)) {
          onSelect(themeKey);
        }
      }}
    >
      <ThemeCard
        selected={selected}
        themeName={themeName}
        thumbnail={thumbnail}
        themeColors={themeColors}
        showStatus={showStatus}
        showEdit={showEdit}
        onDetailedSettings={onDetailedSettings}
      />
    </div>
  );
};
